<template>
  <div>
    <modal
      v-bind:name="'rating' + travel.key"
      :adaptive="true"
      height="auto"
      :scrollable="true"
    >
      <div class="row margin-10">
        <div class="col">
          <div class="row justify-content-md-center">
            <div class="col-md-auto">
              <star-rating
                v-model="form_rating"
                :show-rating="false"
              ></star-rating>
            </div>
          </div>
          <div class="row justify-content-md-center sized-top-20">
            <div class="col-md-auto">
              <button
                id="sign-in"
                type="button"
                class="btn btn-dark"
                v-on:click="saveRating"
              >
                Salvar minha nota
              </button>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <div class="card">
      <div class="card-body">
        <div class="row" v-if="is_loading == false">
          <div class="col" v-bind:id="'print' + travel.key">
            <div
              class="row"
              v-if="
                travel.data.address.description.length > 0 &&
                  travel.data.address.number.length > 0
              "
            >
              <div class="col">
                <span class="text-bold">
                  Origem:
                  <span class="text-normal"
                    >{{ travel.data.address.description.toUpperCase() }},
                    {{ travel.data.address.number.toUpperCase() }}</span
                  >
                </span>
              </div>
            </div>
            <div
              class="row"
              v-if="
                travel.data.address.destiny_address.length > 0 &&
                  travel.data.address.destiny_number.length > 0
              "
            >
              <div class="col">
                <span class="text-bold">
                  Destino:
                  <span class="text-normal"
                    >{{ travel.data.address.destiny_address.toUpperCase() }},
                    {{ travel.data.address.destiny_number.toUpperCase() }}</span
                  >
                </span>
              </div>
            </div>
            <div
              class="row"
              v-if="
                travel.data.address.destiny_phone.length > 0 &&
                  travel.data.address.destiny_name.length > 0
              "
            >
              <div class="col">
                <span class="text-bold">
                  Destinatário:
                  <span class="text-normal"
                    >({{ travel.data.address.destiny_phone.toUpperCase() }})
                    {{ travel.data.address.destiny_name.toUpperCase() }}</span
                  >
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <span class="text-bold">
                  Recebimento:
                  <span class="text-normal"
                    >{{
                      travel.data.address.destiny_type == 0
                        ? 'DINHEIRO'
                        : 'CARTÃO'
                    }}
                    {{
                      travel.data.address.destiny_value > 0.05
                        ? 'R$' + travel.data.address.destiny_value.toFixed(2)
                        : ''
                    }}</span
                  >
                </span>
              </div>
            </div>
            <div class="row" v-if="stats != 3">
              <div class="col">
                <span class="text-bold">
                  Motorista:
                  <span class="text-normal">{{
                    travel.data.driver != null && travel.data.driver != ''
                      ? travel.data.driver.toUpperCase()
                      : 'Aguardando o motorista...'
                  }}</span>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <span class="text-bold">
                  Valor:
                  <span class="text-normal"
                    >R${{ travel.data.value.toFixed(2) }}</span
                  >
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <span class="text-bold">
                  Pagamento:
                  <span class="text-normal">{{
                    travel.data.payment == '0'
                      ? 'DINHEIRO'
                      : travel.data.payment == '1'
                      ? travel.data.payment_id != null
                        ? 'CARTÃO PELO APP'
                        : 'CARTÃO'
                      : 'CASHBACK'
                  }}</span>
                </span>
              </div>
            </div>
            <div class="row" v-if="travel.data.description.lenght > 0">
              <div class="col">
                <span class="text-bold">
                  Observação:
                  <span class="text-normal">{{
                    travel.data.description.toUpperCase()
                  }}</span>
                </span>
              </div>
            </div>
            <div class="row" v-if="travel.data.os.lenght > 0">
              <div class="col">
                <span class="text-bold">
                  OC:
                  <span class="text-normal">{{
                    travel.data.os.toUpperCase()
                  }}</span>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <span class="text-bold">
                  Data:
                  <span class="text-normal">{{ ftdate }} {{ fthour }}</span>
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-auto hour-top">
            <div class="row">
              <div class="col aling-center">
                <i class="fa fa-motorcycle" style="font-size:30px;"></i>
              </div>
              <div class="col aling-center" v-if="travel.data.payment == '0'">
                <i
                  class="fa fa-money"
                  style="font-size:30px;  color:green;"
                ></i>
              </div>
              <div
                class="col aling-center"
                v-else-if="travel.data.payment == '1'"
              >
                <i
                  class="fa fa-credit-card"
                  style="font-size:30px; color:blue;"
                ></i>
              </div>
              <div class="col aling-center" v-else>
                <i
                  class="fa fa-id-card"
                  style="font-size:30px; color:black;"
                ></i>
              </div>
            </div>
            <div
              class="row justify-content-md-center sized-top-20"
              v-if="stats >= 0 && stats < 3"
            >
              <div class="col-md-auto aling-center">Recebida pela central</div>
              <div class="col-md-auto aling-center">
                <i
                  class="fa fa-check"
                  style="font-size:25px;  color:green;"
                ></i>
              </div>
            </div>
            <div
              class="row justify-content-md-center"
              v-if="stats >= 1 && stats < 3"
            >
              <div class="col-md-auto aling-center">
                O entregador está a caminho
              </div>
              <div class="col-md-auto aling-center">
                <i
                  class="fa fa-check"
                  style="font-size:25px;  color:green;"
                ></i>
              </div>
            </div>
            <div class="row justify-content-md-center" v-if="stats == 2">
              <div class="col-md-auto aling-center">Corrida finalizada</div>
              <div class="col-md-auto aling-center">
                <i
                  class="fa fa-check"
                  style="font-size:25px;  color:green;"
                ></i>
              </div>
            </div>
            <div
              class="row justify-content-md-center sized-top-20"
              v-else-if="stats == 3"
            >
              <div class="col-md-auto aling-center">Corrida cancelada</div>
              <div class="col-md-auto aling-center">
                <i class="fa fa-ban" style="font-size:25px;  color:red;"></i>
              </div>
            </div>
            <div class="row" v-if="stats < 2">
              <div class="col">
                <div class="loader"></div>
              </div>
            </div>
          </div>
          <div class="col-md-auto">
            <div class="row">
              <div class="col">
                <div class="dropdown">
                  <button
                    class="btn btn-secondary dropdown-toggle mobile"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Opções
                  </button>
                  <div class="dropdown-menu">
                    <a
                      class="dropdown-item"
                      href="#"
                      onclick="return false;"
                      v-on:click="cancelTravel"
                      v-if="stats == 0"
                      >Cancelar entrega</a
                    >
                    <a
                      class="dropdown-item"
                      href="#"
                      onclick="return false;"
                      v-on:click="contactSuport"
                      >Suporte</a
                    >
                    <a
                      class="dropdown-item"
                      href="#"
                      onclick="return false;"
                      v-on:click="setRating"
                      v-if="stats == 2 && travel.data.rating == null"
                      >Avaliar</a
                    >
                    <a
                      class="dropdown-item"
                      href="#"
                      onclick="return false;"
                      v-on:click="printTravel"
                      >Imprimir</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div
              class="row justify-content-md-center sized-top-10"
              v-if="travel.data.rating != null"
            >
              <div class="col-md-auto">
                <span class="text-bold">{{
                  travel.data.rating.toFixed(2)
                }}</span>
                <i class="fa fa-star" style="font-size:18px;"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-else>
          <div class="col">
            <div class="loader"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db, functions } from '../configs/firebase.js';
import moment from 'moment-timezone';

export default {
  name: 'Travel',
  props: {
    travel: Object
  },
  data() {
    return {
      is_loading: false,
      rating_key: null,
      form_rating: 0,
      newTravel: this.travel
    };
  },
  computed: {
    fthour: function() {
      try {
        return moment(this.newTravel.data.dates.create).format('HH:mm');
      } catch (e) {
        //console.log(e);
        return '--:--';
      }
    },
    ftdate: function() {
      try {
        return moment(this.newTravel.data.dates.create).format('DD/MM/YYYY');
      } catch (e) {
        //console.log(e);
        return '--/--/----';
      }
    },
    stats: function() {
      try {
        return parseInt(this.newTravel.data.keys.user_stats.split('___')[1]);
      } catch (e) {
        //console.log(e);
        return 0;
      }
    },
    user: function() {
      return this.$root.user;
    }
  },
  mounted() {},
  methods: {
    printTravel() {
      this.$htmlToPaper('print' + this.newTravel.key);
    },
    async cancelTravel() {
      try {
        this.is_loading = true;

        let payload = {
          key: this.newTravel.key
        };

        let cancelTravel = functions.httpsCallable('cancelTravel_onCall');
        let result = await cancelTravel(payload);

        if (result.data) {
          alert('Sua entrega foi cancelada com sucesso na central');
        } else {
          alert(
            'Não conseguimos mais cancelar por aqui, contate o suporte da corrida'
          );
        }
      } catch (e) {
        //console.log(e);
      } finally {
        this.is_loading = false;
      }
    },
    contactSuport() {
      var win = window.open(
        'https://api.whatsapp.com/send?phone=553535226006&text=Oi sou ' +
          this.user.displayName +
          ' quero falar sobre a entrega pedida na rua ' +
          this.newTravel.data.address.description.toUpperCase() +
          ' ' +
          this.newTravel.data.address.number.toUpperCase() +
          ' em ' +
          this.fthour +
          ' às ' +
          this.ftdate,
        '_blank'
      );
      win.focus();
    },
    setRating() {
      this.rating_key = this.newTravel.key;
      this.$modal.show('rating' + this.newTravel.key);
    },
    async saveRating() {
      try {
        this.$modal.hide('rating' + this.newTravel.key);

        this.is_loading = true;

        await db
          .ref('travels/' + this.newTravel.key + '/rating')
          .transaction((x) => {
            x = this.form_rating;
            return x;
          });

        this.newTravel.data.rating = this.form_rating;

        alert('Obrigado por nos ajudar a melhorar!');
      } catch (e) {
        //console.log(e);

        alert('Erro ao salvar a sua nota, tente novamente');
      } finally {
        this.is_loading = false;
      }
    }
  }
};
</script>

<style>
@media only screen and (max-width: 912px) {
  .hour-top {
    margin-top: 20px;
  }
}
</style>
